var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVoluntary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.624,
    height: 50.74,
    viewBox: "0 0 35.624 50.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hand-yes-volunteer-fingers-svgrepo-com",
    d: "M81.894,23.163a2.745,2.745,0,0,0-3.909-.021L69.877,31.7l-.062.062c-5.247.021-9.506,3.457-9.506,7.675H59.116c0-4.856,4.753-8.806,10.617-8.868l-.021-3.992s-.021-17.572-.021-17.592a2.417,2.417,0,0,0-4.815.288v15l-1.07.041L63.787,7.607a2.418,2.418,0,0,0-4.835.021V24.294H57.8l.021-13.086a2.418,2.418,0,0,0-4.835,0V24.294h-1.07l.021-7.037a2.418,2.418,0,0,0-4.835.021V40.117c0,2.716,1.4,5.021,3.333,5.782v9.959h.041v.082l16.708-.082V45.343a12.843,12.843,0,0,0,1.564-.679,11.6,11.6,0,0,0,6.07-6.687c.6-.885,7.572-11.564,7.572-11.564A2.723,2.723,0,0,0,81.894,23.163Z",
    transform: "translate(-47.1 -5.2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoluntary);
export default __webpack_public_path__ + "static/media/icon-voluntary.828f899a72cce60ee698f92c6ddec40c.svg";
export { ForwardRef as ReactComponent };